import ReactDOM from 'react-dom';
const createNode = (children) => {
    const mountPoint = document.createElement('div');
    mountPoint.className = 'g2-tooltip';
    ReactDOM.render(children, mountPoint);
    return mountPoint;
};
export default createNode;
